{
  "EMOJI": {
    "PLACEHOLDER": "Wyszukaj emoji",
    "NOT_FOUND": "Nie znaleziono emoji pasującego do wyszukiwania",
    "REMOVE": "Usuń"
  },
  "EMOJI_ICON_PICKER": {
    "TABS": {
      "ICONS": "Icons",
      "EMOJIS": "Emojis"
    },
    "SEARCH_EMOJI": "Search emoji…",
    "SEARCH_ICON": "Search icons…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "Nie znaleziono emoji pasującego do wyszukiwania",
    "NO_ICON": "No icons match your search",
    "REMOVE": "Usuń",
    "STYLE": {
      "OUTLINE": "Outline icons",
      "FILLED": "Filled icons"
    },
    "COLORS": {
      "SLATE": "Slate",
      "RED": "Red",
      "ORANGE": "Orange",
      "AMBER": "Amber",
      "GREEN": "Green",
      "TEAL": "Teal",
      "BLUE": "Blue",
      "INDIGO": "Indigo",
      "VIOLET": "Violet",
      "PINK": "Pink"
    }
  }
}
